import React from 'react';
import FancyInput from '@/component/form/numinput/index.jsx';
import { Map } from 'immutable';
import { Currency } from '@/consts/currency';

export class ValueInput extends React.Component {
  constructor(props) {
    super(props);
    this.handleInputClick = this.handleInputClick.bind(this);
    this.onChangeRate = this.onChangeRate.bind(this);
    this.state = { data: new Map() };
  }
  onChangeRate(currency, value) {
    if (this.props.item.setRate) {
      this.props.item.setRate(currency, value);
    }
  }
  handleInputClick(e) {
    e.stopPropagation();
  }
  render() {
    return (
      <span
        style={{ display: 'flex', flexDirection: 'row', height: 40, alignItems: 'center',
          justifyContent: 'space-between', width: '100%' }}
      >
        <span
          style={{ paddingRight: 5, marginRight: 5 }}
        >
          {this.props.item.label}
        </span>
        {this.props.item.value == Currency.DOLLAR ? '' :
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
            <span style={{ marginRight: 5 }}>{`${this.props.item.value}/${Currency.DOLLAR}`}</span>
            <FancyInput
              className="form-control currency-input-rate"
              fraction={4}
              positive
              negative={false}
              value={this.props.item.rate}
              onChange={(e, value) => this.onChangeRate(this.props.item.value, value)}
              type="number" onClick={this.handleInputClick}
            />
          </div>
        }
      </span>);
  }
}

ValueInput.propTypes = {
  item: React.PropTypes.object.isRequired,
};
